import { useEffect } from 'react';
import { useSocket } from '../contexts/NotificationSocketProvider';
import toast from 'react-hot-toast';

const useNotificationListener = (onNotification) => {
  const socketRef = useSocket();
  const socket = socketRef?.current;

  useEffect(() => {
    if (!socket) return;

    socket.on('notification', (data) => {
      if (data.type === 'FRIEND_REQUEST') {
        toast.success(`👥 New friend request from ${data.from}`);
      }
      if (data.type === 'NEW_MESSAGE') {
        toast(`💬 New message from ${data.from}`);
      }

      if (onNotification) onNotification(data);
    });

    return () => {
      socket.off('notification');
    };
  }, [socket, onNotification]);
};

export default useNotificationListener;
